module.exports = __webpack_public_path__ + "static/media/no-view.9eb8c71c.png";